/**
 * Environment-driven endpoints for the web client.
 *
 * Production defaults point at `solvr.es` so the static bundle can
 * ship to `app.solvr.es` and Just Work. Override locally with
 * `web/.env.local` (gitignored — see `.gitignore`):
 *
 *   VITE_RELAY_URL=ws://localhost:3001/ws
 *   VITE_RELAY_HTTP_URL=http://localhost:3001
 *
 * Vite injects `import.meta.env.VITE_*` at build time. We resolve to a
 * single export so other modules don't re-read `import.meta.env`
 * (keeps the surface for tests + future hosting changes small).
 */

const PROD_RELAY_URL = 'wss://solvr.es/ws';
const PROD_RELAY_HTTP_URL = 'https://solvr.es/api';

export const RELAY_URL: string = import.meta.env.VITE_RELAY_URL ?? PROD_RELAY_URL;
export const RELAY_HTTP_URL: string = import.meta.env.VITE_RELAY_HTTP_URL ?? PROD_RELAY_HTTP_URL;
